import React, { useEffect, useState, useRef } from "react";

import { useNavigate } from "react-router-dom";
import Countable from "./Countable";
import { StartConversation } from "../Casinoengine/StartConversation";
import ClientLogo from "../Casinoengine/ClientLogo";
import FiltersForm from "./FiltersForm";
import Card from "./Card";

import EvoPlay from '../../images/gameLogo/Evoplay.png'
import RelaxGame from '../../images/gameLogo/RelaxGaming.jpg';
import Slotmil from '../../images/gameLogo/Slotmill.jpg'
import Booming from '../../images/gameLogo/Booming-Games.jpg'
import Irondog from '../../images/gameLogo/Irondog-Studio.jpg'
import Playson from '../../images/gameLogo/Playson.jpg'
import Pragmatic from '../../images/gameLogo/Pragmatic.jpg'
import Red from '../../images/gameLogo/Red-Rake-Gaming.jpg'

const CasinoContent = () => {
  const navigate = useNavigate();
  const logos = [
    {
      url: '',
      img: EvoPlay,
      alt: "bet-at-home",
    },
    {
      url: "",
      img: RelaxGame,
      alt: "Tipico",
    },
    {
      url: "",
      img: Slotmil,
      alt: "OPAP",
    },
    {
      url: "",
      img: Booming,
      alt: "Booming",
    },
    {
      url: "",
      img: Irondog,
      alt: "Irondog",
    },
    {
      url: "",
      img: Playson,
      alt: "Playson",
    },
    {
      url: "",
      img: Pragmatic,
      alt: "Pragmatic",
    },
    {
      url: "",
      img: Red,
      alt: "Red",
    },
    // {
    //   url: "https://everymatrix.com/clients/norsk-tipping/",
    //   img: "https://everymatrix.com/wp-content/uploads/2019/03/Frame-2.svg",
    //   alt: "Norsk Tipping",
    // },
    // {
    //   url: "https://everymatrix.com/clients/szerencsejatek-zrt/",
    //   img: "https://everymatrix.com/wp-content/uploads/2023/01/szerencsejatek.svg",
    //   alt: "Szerencsejáték ZRT",
    // },
    // {
    //   url: "https://everymatrix.com/clients/veikkaus/",
    //   img: "https://everymatrix.com/wp-content/uploads/2022/10/veikkaus-logo.png",
    //   alt: "Veikkaus",
    // },
    // {
    //   url: "https://everymatrix.com/clients/pinnacle/",
    //   img: "https://everymatrix.com/wp-content/uploads/2024/10/image-60.png",
    //   alt: "Pinnacle",
    // },
    // {
    //   url: "https://everymatrix.com/clients/intralot/",
    //   img: "https://everymatrix.com/wp-content/uploads/2022/09/Frame-36.svg",
    //   alt: "Intralot",
    // },
    // {
    //   url: "https://everymatrix.com/clients/flutter-entertainment/",
    //   img: "https://everymatrix.com/wp-content/uploads/2019/12/Group-3.svg",
    //   alt: "Flutter Entertainment",
    // },
    // {
    //   url: "https://everymatrix.com/clients/betparx/",
    //   img: "https://everymatrix.com/wp-content/uploads/2023/10/betparx.svg",
    //   alt: "betPARX",
    // },
    // {
    //   url: null,
    //   img: "https://everymatrix.com/wp-content/uploads/2024/11/BetGoodwinLogoNew-2-1-3.png",
    //   alt: "Private: betgoodwin",
    // },
    // {
    //   url: "https://everymatrix.com/clients/malta-national-lottery/",
    //   img: "https://everymatrix.com/wp-content/uploads/2022/07/national-lottery.svg",
    //   alt: "Malta National Lottery",
    // },
  ];

  const cardData = [
    {
      title: "CasinoEngine Turnkey Solution",
      description:
        "Ideal for operators seeking a complete platform setup, this solution is powered by our iGaming management platform, GamMatrix, and CasinoEngine. Enjoy seamless cross-product bonusing across brands and verticals.",
      link: "https://everymatrix.com/casinoengine/business-models/",
      gaClick: "component-casinoengine-turnkey",
    },
    {
      title: "CasinoEngine Integration",
      description:
        "Perfect for operators with their own iGaming platform who want a premium casino content solution. Benefit from industry-leading content selection and seamless cross-product bonusing.",
      link: "https://everymatrix.com/casinoengine/business-models/",
      gaClick: "component-casinoengine",
    },
    {
      title: "SlotMatrix Aggregation",
      description:
        "Gain fast access to the world’s largest collection of top-tier gaming content, including market-specific games. Leverage tournaments, challenges, and powerful promotional tools across all content.",
      link: "https://everymatrix.com/casinoengine/business-models/",
      gaClick: "component-slotmatrix",
    },
  ];
  return (
    <>
      <main className="overflow-hidden">
        <section className="simple-intro">
          <div className="container container_custom">
            <div className="row">
              <div className="col-xl-5 col-lg-6">
                <h1 className="section-title heading_left">
                  Expanded Games, <br /> Endless Possibilities
                </h1>
                <div className="description">
                  <p>
                    CasinoEngine serves as your all-in-one solution for casino
                    content. We are committed to rapidly onboarding new casino
                    providers, enabling quick market entry for clients, and
                    consistently refreshing their existing game portfolios.
                  </p>
                </div>
                <div className="pt-5">
                  <a
                    href="/connect"
                    className="btn btn_blue"
                    data-ga-click="hero-contact-us"
                  >
                    Contact us
                  </a>
                </div>
              </div>
              <div className="img-holder">
                <img
                  src="https://everymatrix.com/wp-content/uploads/2019/06/CE-content1.png"
                  className="illustration"
                />
              </div>
            </div>
          </div>
          <a href="#explore" className="explore"></a>
        </section>
        <Countable />
        <section className="product-clients sec-padd-t grayp">
          <div className="container">
            <div className="row">
              <div className="col-md-12 text-center">
                <h2 className="section-title">Gaming Partners</h2>
                <p>
                  Our gaming partners are vital to our efforts to deliver
                  CasinoEngine, the largest casino content aggregator on the
                  market, <br />
                  which grants online operators with access to a world-beating
                  selection of casino games in one casino software platform.
                </p>
                <div className="col-md-8 mx-auto">
                  <div className="filters-casino m-t-50 m-b-20">
                    <FiltersForm />
                  </div>
                </div>
                <ul className="list-clients row">
                  {logos.map((logo, index) => (
                    <ClientLogo logo={logo} key={index} />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className="sec-padd">
          <div className="components  pb-5">
            <div className="container container_custom">
              <div className="row g-md-5 g-4">
                {cardData.map((item, index) => (
                  <Card
                    key={index}
                    title={item.title}
                    description={item.description}
                    link={item.link}
                    gaClick={item.gaClick}
                  />
                ))}
              </div>
            </div>
          </div>
        </section>
        <StartConversation />
      </main>
    </>
  );
};

export default CasinoContent;
